var map = {
	"./proximasoft-bold-webfont.woff2": 141,
	"./proximasoft-regular-webfont.woff2": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/font ^\.\/.*\.woff2$
// module id = 58
// module chunks = 3